module.exports = __webpack_public_path__ + "static/media/fireProtection.3e7b9d09.jpeg";